<template>
  <transition name="modal-fade">
    <Modal
      :title="$t('common.searchaddressmodal.9573')"
      @close="$emit('close')"
    >
      <div class="ly_pop_content ly_pop_msg ly_txt modalAlign">
        <div class="ly_inner">
          <vue-daum-postcode
            :theme="postcodeTheme"
            class="w-full"
            @complete="onComplete"
          />
        </div>
        <div class="btnWrap">
          <button class="box_btn dull w-full" @click="$emit('close')">
            <span class="an_t">{{ $t('library.deletemodal.close') }}</span>
          </button>
        </div>
      </div>
    </Modal>
  </transition>
</template>

<script>
import { VueDaumPostcode } from 'vue-daum-postcode'

export default {
  name: 'SearchAddressModal',

  components: { VueDaumPostcode },

  data() {
    return {
      postcodeTheme: {
        bgColor: '#f0f5fa',
        emphTextColor: '#007aff',
        searchBgColor: '#FFF',
        contentBgColor: '#F0F5FA',
        pageBgColor: '#F0F5FA'
      }
    }
  },

  methods: {
    onComplete(data) {
      this.$emit('complete', data)
    }
  }
}
</script>

<style lang="scss" scoped>
.btnWrap {
  padding: 0px 25px 25px 25px;
}

.ly_inner {
  padding: 22px 25px 0px 25px !important;
}
</style>

<style lang="scss">
.w-full {
  width: 100%;
}

.vue-daum-postcode-container {
  max-height: 80vh !important;
}

.modalAlign {
  max-height: 100vh;
  margin-top: 45px;
}

@media (max-width: 800px) {
  .modalAlign {
    width: 95%;
    position: absolute;
    bottom: 15px;
    margin: 0 auto;
  }
}

.modalBtn {
  width: 100%;
  margin: 10px;
}

.popup_foot,
.link_infomation,
.txt_by {
  color: #ffffff !important;
}
</style>
